import CreditCardSummaryPage from './CreditCardSummaryPage';

const CreditCardSummary = () => {
  return (
    <div className="credit-card-form-container">
      <CreditCardSummaryPage />
    </div>
  );
};

export default CreditCardSummary;
